// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LocalePicker$Web from "lumi-web/lib/es6/src/LocalePicker.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as I18n$LumiAuthentication from "./I18n.res.js";

function Modal$Form(props) {
  let onSubmit = props.onSubmit;
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx("div", {
        className: "modal-background"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("header", {
            children: [
              JsxRuntime.jsx("p", {
                children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                  entry: props.title
                }),
                className: "modal-card-title"
              }),
              JsxRuntime.jsx(LocalePicker$Web.make, {})
            ],
            className: "modal-card-head"
          }),
          props.children
        ],
        className: "modal-card"
      })
    ],
    className: "modal is-active",
    onSubmit: event => {
      event.preventDefault();
      onSubmit(event);
    }
  });
}

let Form = {
  make: Modal$Form
};

function Modal(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        className: "modal-background"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("header", {
            children: [
              JsxRuntime.jsx("p", {
                children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                  entry: props.title
                }),
                className: "modal-card-title"
              }),
              JsxRuntime.jsx(LocalePicker$Web.make, {})
            ],
            className: "modal-card-head"
          }),
          props.children
        ],
        className: "modal-card"
      })
    ],
    className: "modal is-active"
  });
}

let T;

let make = Modal;

export {
  T,
  Form,
  make,
}
/* LocalePicker-Web Not a pure module */
